import { where } from 'firebase/firestore'

import { getConvertedData } from '../../../models/interface.helper'

import FirestoreService from '../../firestoreService'

import { RiderTeamMemberModel } from '../../../models/rider-team-member/riderTeamMember.model'

import { IRiderTeamMemberInterface } from '../../../models/rider-team-member/riderTeamMember.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getByRider = async (registrationId: string, riderId: string) => {
  const riderTeamMembers: IRiderTeamMemberInterface[] = []
  const riderTeamMembersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
    [
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId),
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.RIDER_ID.KEY, '==', riderId),
    ]
  )

  if (riderTeamMembersSnaps.size > 0) {
    riderTeamMembersSnaps.forEach((currDoc) => {
      const current = getConvertedData(RiderTeamMemberModel.fromFirestoreDoc(currDoc).toObject())
      riderTeamMembers.push(current)
    })
  }

  return riderTeamMembers
}

const getByRegistrationId = async (registrationId: string) => {
  const riderTeamMembers: IRiderTeamMemberInterface[] = []
  const riderTeamMembersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
    [where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId)]
  )

  if (riderTeamMembersSnaps.size > 0) {
    riderTeamMembersSnaps.forEach((currDoc) => {
      const current = getConvertedData(RiderTeamMemberModel.fromFirestoreDoc(currDoc).toObject())
      riderTeamMembers.push(current)
    })
  }

  return riderTeamMembers
}

const getByEventId = async (eventId: string) => {
  const riderTeamMembers: IRiderTeamMemberInterface[] = []

  const riderTeamMembersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
    [where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.EVENT_ID.KEY, '==', eventId)]
  )

  if (riderTeamMembersSnaps.size > 0) {
    riderTeamMembersSnaps.forEach((currDoc) => {
      const current = getConvertedData(RiderTeamMemberModel.fromFirestoreDoc(currDoc).toObject())
      riderTeamMembers.push(current)
    })
  }

  return riderTeamMembers
}

const getRiderTeamMembers = async ({
  teamMemberId,
  role,
  riderId,
  horseId,
  registrationDocId,
}: {
  teamMemberId: string
  role: string
  riderId: string
  horseId: string
  registrationDocId: string
}) => {
  const riderTeamMembers: IRiderTeamMemberInterface[] = []

  const riderTeamMembersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
    [
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.TEAM_MEMBER_ID.KEY, '==', teamMemberId),
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.TEAM_MEMBER_ROLE.KEY, '==', role),
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.RIDER_ID.KEY, '==', riderId),
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.HORSE_ID.KEY, '==', horseId),
      where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationDocId),
    ]
  )

  if (riderTeamMembersSnaps.size > 0) {
    riderTeamMembersSnaps.forEach((currDoc) => {
      const current = getConvertedData(RiderTeamMemberModel.fromFirestoreDoc(currDoc).toObject())
      riderTeamMembers.push(current)
    })
  }

  return riderTeamMembers
}

const RiderTeamMemberService = {
  getByRider,
  getByRegistrationId,
  getByEventId,
  getRiderTeamMembers,
}

export default RiderTeamMemberService
